import { CouponDuration } from './userCoupons.slice'

export const formatCouponDuration = ({
  duration,
  durationInMonths,
}: {
  duration: CouponDuration | undefined
  durationInMonths: number | null
}): string => {
  switch (duration) {
    case 'forever':
      return 'forever'
    case 'once':
      return 'one-time'
    case 'repeating':
      return durationInMonths
        ? `for ${durationInMonths} month${durationInMonths === 1 ? '' : 's'}`
        : 'repeating'
    default:
      return 'N/A'
  }
}
